import { useState } from "react";

export enum TokenTransferSteps {
  WhatToExpect,
  VerifyAccount,
  ReceivingAddress,
  ReviewDetails,
  Transferring,
}

const STEPS_WITH_PAGINATION = [
  TokenTransferSteps.VerifyAccount,
  TokenTransferSteps.ReceivingAddress,
  TokenTransferSteps.ReviewDetails,
  TokenTransferSteps.Transferring,
];

export const useTokenTransferModalSteps = (initialStep: TokenTransferSteps) => {
  const [currentStep, setCurrentStep] =
    useState<TokenTransferSteps>(initialStep);

  const [isStepError, setStepError] = useState<boolean>(false);

  const nextStep = () => {
    setCurrentStep((cur: TokenTransferSteps) => cur + 1);
  };
  const prevStep = () => {
    setCurrentStep((cur: TokenTransferSteps) => cur - 1);
  };

  const isStepShowing = (step: TokenTransferSteps) => {
    return step === currentStep;
  };

  const isPaginationShowing =
    STEPS_WITH_PAGINATION.includes(currentStep) && !isStepError;

  return {
    currentStep,
    nextStep,
    prevStep,
    isPaginationShowing,
    isStepShowing,
    setCurrentStep,
    setStepError,
  };
};
